export default function CTA() {
  return (
    <section
      style={{
        background: "#222",
        color: "#FFF",
        padding: "140px 32px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          maxWidth: 900,
          margin: "0 auto",
        }}
      >
        <p
          style={{
            color: "#C9A66B",
            letterSpacing: ".18em",
            fontFamily: "'JetBrains Mono', monospace",
            marginBottom: 24,
          }}
        >
          YOUR NEXT STAY AWAITS
        </p>

        <h2
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: "clamp(42px, 6vw, 72px)",
            fontWeight: 400,
            lineHeight: 1.1,
            marginBottom: 28,
          }}
        >
          Experience comfort
          <br />
          that feels like home.
        </h2>

        <p
          style={{
            color: "rgba(255,255,255,.75)",
            fontSize: 19,
            lineHeight: 1.9,
            maxWidth: 650,
            margin: "0 auto 50px",
          }}
        >
          Whether you're travelling for business, relocation or a family
          getaway, Ebenezer Serviced Apartments & Suites offers thoughtfully
          designed accommodation in the heart of Whitefield.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 20,
            flexWrap: "wrap",
          }}
        >
          <a
            href="https://wa.me/91XXXXXXXXXX"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: "16px 36px",
              background: "#C9A66B",
              color: "#222",
              textDecoration: "none",
              fontWeight: 600,
              transition: ".3s",
            }}
          >
            Book Your Stay
          </a>

          <a
            href="tel:+91XXXXXXXXXX"
            style={{
              padding: "16px 36px",
              border: "1px solid rgba(255,255,255,.3)",
              color: "#FFF",
              textDecoration: "none",
              fontWeight: 600,
              transition: ".3s",
            }}
          >
            Call Reception
          </a>
        </div>

        <div
          style={{
            marginTop: 80,
            display: "flex",
            justifyContent: "center",
            gap: 50,
            flexWrap: "wrap",
            color: "rgba(255,255,255,.65)",
            fontSize: 15,
          }}
        >
          <span>✓ Free Wi-Fi</span>
          <span>✓ Free Parking</span>
          <span>✓ Daily Housekeeping</span>
          <span>✓ Prime Whitefield Location</span>
        </div>
      </div>
    </section>
  );
}